/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { columns } from './utils/list_data';
import React, { useState, useEffect } from 'react';
import { useStructure } from './hooks/useStructure';
import FullTable from 'src/common/components/FullTable';
import PageLayout from 'src/common/components/PageLayout';
import { UploadFileMinos } from '../Files/UpaloadFileMinos';

const Structure = () => {
	const {
		data,
		handlePagination,
		setCurrentPage,
		totalResults,
		pagination,
		currentPage,
		setLoader,
		onDownload,
		loader,
	} = useStructure();

	const [hide, setHide] = useState(false);
	const hideActions = ['ENLACE', 'CONSULTA'];
	const [currentFile, setCurrentFile] = useState({});
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();

	const onUploadedFile = () => {
		setLoader(true);
	};

	useEffect(() => {
		setHide(hideActions.includes(systemLevelRole));
		setCurrentFile({
			tipo: 'A',
			entidad: 'ESTRUCTURA',
			ruta: 'Estructura',
			title: 'Archivo Estructura',
			nombre: '',
			idEntidad: '0',
		});
	}, [data]);

	return (
		<PageLayout>
			{Object.keys(currentFile && data).length !== 0 && (
				<section
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'start',
						width: '100%',
						justifyContent: 'space-between',
						padding: '4px  6px 8px 6px ',
						gap: '8px',
					}}
				>
					<h2>Estructura</h2>
					{hide === false && (
						<div style={{ width: '100%' }}>
							<UploadFileMinos
								control={
									<Button
										name="nombreFile"
										id={
											'BtnuploadMinos' +
											currentFile.idEntidad.toString() +
											currentFile.title.replaceAll(' ', '')
										}
										className="col-auto mr-auto btn btn-outline-primary btn-lg btn-block"
									>
										{loader ? (
											<div className="flex items-center gap-2">
												<div
													className="spinner-border text-primary"
													role="status"
												></div>
												<span>Cargando archivo...</span>
											</div>
										) : (
											'Cargar Nuevo Archivo'
										)}
									</Button>
								}
								onUploaded={onUploadedFile}
								idEntidad={currentFile.idEntidad || ''}
								tipo={currentFile.tipo}
								entidad={currentFile.entidad}
								ruta={currentFile.ruta}
								title={currentFile.title}
								nombre={currentFile.nombre}
								idFile={currentFile.id}
								setOpen={setLoader}
								allFiles={data}
								validUniqueName={true}
								estructureModule={true}
							/>
						</div>
					)}
				</section>
			)}
			<FullTable
				title=""
				items={data}
				columns={columns(onDownload)}
				showPagination
				handlePagination={handlePagination}
				sizePerPageTable={pagination}
				totalPages={totalResults}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
			{/* <DeleteStructure
				open={deleteModal}
				onSuccess={onSuccess}
				onDelete={onDelete}
				unit={idStructure}
				onClose={() => {
					setDeleteModal(false);
				}}
			/> */}
		</PageLayout>
	);
};

export default Structure;
